import {
	SnippetBodyFormat,
	SnippetScope,
	type Snippet as PlatformSnippet,
} from '@atlassian/editor-snippets-provider/types';

import { SnippetScope as ConfluenceSnippetScope } from '@confluence/fabric-media-support/entry-points/snippetScope.ts';

import type { Snippet as ConfluenceSnippet } from '../types/snippet.ts';
import { wrapAdfWithDocNode } from '../utils/adfUtils.ts';

const mapSnippetScope = (scope: ConfluenceSnippetScope): SnippetScope => {
	switch (scope) {
		case ConfluenceSnippetScope.GLOBAL:
			return SnippetScope.GLOBAL;
		case ConfluenceSnippetScope.SITE:
			return SnippetScope.SITE;
		case ConfluenceSnippetScope.USER:
			return SnippetScope.USER;
	}
};

const getShareId = (shareUrl: string | undefined): string | undefined => {
	const query = shareUrl?.split('?')[1];
	return query ? (new URLSearchParams(query).get('shareId') ?? undefined) : undefined;
};

export const mapConfluenceSnippet = (snippet: ConfluenceSnippet): PlatformSnippet => ({
	resourceId: snippet.ari.toString(),
	snippetId: snippet.snippetId,
	name: snippet.name,
	description: snippet.description,
	bodyFormat: SnippetBodyFormat.ADF,
	body: wrapAdfWithDocNode(snippet.body),
	product: snippet.product,
	label: snippet.label,
	isFavorite: snippet.isFavorite,
	status: snippet.status,
	scope: mapSnippetScope(snippet.scope),
	isShared: snippet.isShared,
	templateType: snippet.templateType,
	createdBy: snippet.createdBy?.displayName ?? '',
	createdAt: snippet.createdAt.getTime().toString(),
	updatedAt: snippet.updatedAt.getTime().toString(),
	insertCount: snippet.insertCount,
	shareId: getShareId(snippet.shareUrl),
});
